<template>
  <div class="main">
    <div class="title_grep_div">
      <h1 class="title_grop_h1">{{ titlebg }}</h1>
      <header-top
        @submitSearch="handleSearch"
        @returnHome="handleReturn"
      ></header-top>
    </div>
    <div class="content">
      <left-content
        class="main-left"
        :leftChart="left_chart"
        v-show="left_item"
      ></left-content>
      <div class="main-content-map" ref="mainContent">
        <!-- <nowTime></nowTime> -->
        <!-- echart最新地图 -->
        <div>
          <myMap
            :maps="user_info"
            :changeData="change_data"
            @zoomMap="handleZoomMap"
          ></myMap>
        </div>
      </div>
      <right-content
        class="main-right"
        :rightChart="right_chart"
        v-show="right_item"
      ></right-content>
      <markerlist
        :pointData="pointslist"
        :DrawerBool="drawer"
        :itemClickCallback="markerlist_item_click"
        :close="closedrawer"
      />
      <infotabs
        :isdialogFormVisible="device_tabs_Visible"
        title="设备台账"
        :formdata ="formdata"
        :device_info="device_info"
        :ishiddeCallBack="editclose"
        >
    </infotabs>
      <alarmList class="list" ref="alarmList"></alarmList>
      <dialogClick
        :show-dialog="showClickDialog"
        @closeDialog="closeDialog_click_win"
        :dialogInfoData="infodata"
      ></dialogClick>
      <Mqttws :info="user_info"></Mqttws>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import dataUrl from "../../libs/js/interfaceAddress.js";
import headerTop from "./header_top/header_top.vue";
import leftContent from "./left_content.vue";
import rightContent from "./right_content.vue";
import mapNew from "./map/mapTest.vue";
import Mqttws from "./mqttws.vue";
import alarmList from "./alarm_list.vue";
import nowTime from "./time.vue";
// import dialogdetail from "../../components/dialog/dialog_details.vue";
import dialogClick from "../../components/dialog/dialog_click_win.vue";
import myMap from "./map/main_map";
import markerlist from "../../components/dialog/marker_Info_list.vue";
import infotabs from "../../components/infotabs/device_info_tabs.vue";

import {
  getUkeyObject,
  checkError,
  getError
} from "../login/Ukey/mToken_System.js"; //验证ukey的方法
import localStorage from "../../libs/js/localStorage.js";

export default {
  data() {
    return {
      formdata: {},
      user_info: {},
      amap_obj: {
        map: null
      },
      pointslist: [],
      drawer: false,
      direction: "rtl",
      titlebg: "房山区燃气非居民用户监管平台",
      map_zoom: 3,
      map_pitch: 0,
      mark_arr: [],
      transformScale: "",
      width: "",
      change_data: [],
      left_chart: [],
      right_chart: [],
      tokenInterval: null,
      refreshData: null,
      left_item: true,
      right_item: true,
      showClickDialog: false,
      device_tabs_Visible: false,
      ISUkey: process.env.VUE_APP_UKEY,
      device_info:{},
      infodata: {
        title: "",
        imei: ""
      }
    };
  },
  components: {
    headerTop,
    leftContent,
    rightContent,
    Mqttws,
    mapNew,
    alarmList, //报警列表
    nowTime, //当前时间,
    myMap, //各种类型地图
    dialogClick,
    markerlist,
    infotabs
  },
  mounted() {
    // this.$nextTick(()=>{
    //     this.init();
    // });
      // this.device_tabsClick({deviceId:69})
    this.getUserInfo();
    this.$bus
      .$off("get-user-info-bus")
      .$on("get-user-info-bus", this.getUserInfo);
    this.$bus
      .$off("dialog-details-marker")
      .$on("dialog-details-marker", this.pushdialog_details);
    this.$bus
      .$off("marker_cluster_click")
      .$on("marker_cluster_click", this.reuqestmarkerInfo);
      this.$bus
      .$off("push_device_tabs")
      .$on("push_device_tabs", this.device_tabsClick);
    //每一小时去获取一次新token
    this.tokenInterval = setInterval(() => {
      //老版本刷新安全码函数，安全码全局保存，不需要请求接口
      // this.get_refres_ukey();
      this.refresh_token();
    }, 715 * 60 * 1000);
    //判断时间是否为凌晨
    // this.refreshData = setInterval(()=>{
    //      this.get_date_time();
    // },10000)
    //24小时刷一次接口
    this.refreshData = setInterval(() => {
      this.$bus.$emit("get-alarmList-bus"); //刷报警列表
      this.$bus.$emit("charts_left_es"); //刷图表
      this.$bus.$emit("charts_right_es"); //刷图表
      this.$bus.$emit("map_init_bus"); //刷地图数据
    }, 118 * 60 * 1000);
    // // 拦截返回的数据
  },
  watch: {
    screenWidth() {
      //如果clientHeight 发生改变，这个函数就会运行
      this.page_main_width();
    }
  },

  computed: {
    ...mapState(["map_type"])
  },
  beforeDestroy() {
    this.$bus.$off("get-user-info-bus", this.getUserInfo);
    if (this.tokenInterval) {
      clearInterval(this.tokenInterval);
    }
    //凌晨刷接口
    if (this.refreshData) {
      clearInterval(this.refreshData);
    }
  },
  methods: {
    handleZoomMap() {
      if (this.left_item && this.left_item) {
        this.left_item = false;
        this.right_item = false;
        this.$refs.mainContent.style.width = "100%";
        var docElm = document.documentElement;
        //W3C
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        }
        //FireFox
        else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        }
        //Chrome等
        else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        }
        //IE11
        else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
      } else {
        this.left_item = true;
        this.right_item = true;
        this.$refs.mainContent.style.width = "100%";
        // window.location.reload();
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    closeDialog_click_win() {
      console.log("数据展示内容-=-=-=-=detailsclose-=");
      this.showClickDialog = false;
    },
     // 关闭修改页面回调
     editclose() {
      this.device_tabs_Visible = false
    },
    //头部搜索
    handleSearch(value, id) {
      if (value) {
        this.change_data = value;
      } else {
        this.change_data = [[]];
      }
    },
    handleReturn() {
      var i = [[]];
      this.handleSearch(i);
    },
    //判断是否为凌晨，刷新接口
    get_date_time() {
      if (
        new Date().getHours() === 0 &&
        new Date().getMinutes() === 0 &&
        new Date().getSeconds() === 0
      ) {
        this.init();
        this.$bus.$emit("get-alarmList-bus"); //刷报警列表
        this.$bus.$emit("get-chart-init"); //刷图表
        this.$bus.$emit("map_init_bus"); //刷地图数据
        // console.log("凌晨了")
      } else {
        // console.log("还没过今天");
      }
    },
    //获取安全码
    get_refres_ukey() {
      console.log("获取安全码-=-=-=-=--=");
      this.$http
        .get(dataUrl.interfaceAddress.ukeyInfo, {})
        .then(res => {
          if (res.data.code === 1) {
            let ukey = res.data.data.key;
            let Base64 = require("js-base64").Base64;
            Base64.decode(ukey); //解密
            let key = Base64.decode(ukey);
            this.refresh_token(key);
          } else {
            let message = res.data.info;
            this.$message.error(message);
            window.localStorage.clear();
            this.$router.replace({
              path: "/login"
            });
            //关闭mqtt
            this.$bus.$emit("closeMqtt");
          }
        })
        .catch(err => {
          console.log(err);
          // reject(err)
        });
    },
    device_tabsClick(item){
      console.log('设备台账回调',item)
      this.formdata = item
      this.$http.get(dataUrl.interfaceAddress.getDevDevice_base_info,{params:{ device_id: this.formdata.deviceId }}).then (res => {
            this.device_info = res.data.body
            this.device_tabs_Visible = true
          })
         .catch((err) => {
            this.device_info = {}
         });
    },
    markerlist_item_click(item){
       this.$bus.$emit("marker_info_dialogpush",item); //刷报警列表
    },
    reuqestmarkerInfo(array) {
      this.drawer = true;
      this.pointslist = array;
      console.log("reuqestmarkerInfo-=-=-", array);
    },
    //刷新token
    refresh_token() {
      //检测u盾是否存在
      var clients = localStorage.getStore("clientData");
      console.log("获取refresh_token-=-=-=-=--=" + clients.safetycode);
      if (this.ISUkey === "ON") {
        let ukey = getUkeyObject(clients.safetycode);
        if (ukey.num === 1003) {
          //证明检测到ukey未插入
          this.$message.error("未检测到U盾，请查看是否正确插入"); //提示
          console.log("未检测到U盾，请查看是否正确插入-=-=-=-=-=");

          window.localStorage.clear();
          this.$router.replace({
            path: "/login"
          });
          //关闭mqtt
          this.$bus.$emit("closeMqtt");
          return;
        } else if (ukey.num === 1001) {
          this.request_refreshToken();
        }
      } else {
        this.request_refreshToken();
      }
    },
    request_refreshToken() {
      var userid = "monitor_user:" + this.user_info.user_id;
      let params = {
        userKey: userid
      };
      this.$http
        .post(dataUrl.interfaceAddress.refreshToken, params)
        .then(res => {
          console.log("token-=-=-=-=ceshi-=-=-" + res.data.body.access_token);
          if (res.data.code === 0) {
            let token = res.data.body.access_token;
            localStorage.setStore("info", token);
          } else {
            console.log("获取refresh_token-=-=-=res.data.code === 3-=--=");
            let message = res.data.info;
            this.$message.error(message);

            window.localStorage.clear();
            clearInterval(this.tokenInterval);
            this.$router.push({
              path: "/login"
            });
            //关闭mqtt
            this.$bus.$emit("closeMqtt");
          }
        })
        .catch(err => {
          console.log(err);
          // reject(err)
        });
    },
    page_main_width() {
      let main_width = $(".main").width();
      if (main_width < this.minWidth) {
        this.widthChange = true;
      } else {
        this.widthChange = false;
      }
    },
    pushdialog_details(info) {
      console.log("商业品数据展示-=-=-=-", JSON.stringify(info));
      this.infodata = info;
      this.showClickDialog = true;
    },
    async getUserInfo() {
      console.log("获取用户信息-=-=-=-=--=");

      this.$http
        .get(dataUrl.interfaceAddress.userInfoUrl, {})
        .then(res => {
          console.log("用户信息=-=-=-=-", res.data.body);
          if (res.data.code === 0) {
            if (res.data.body) {
              this.user_info = res.data.body;
              var charts_list = res.data.body.chartsList;
              // this.titlebg = res.data.body.sysTitle;
              // localStorage.setTitleStore("sysTitle", res.data.body.sysTitle);

              if (charts_list.length > 0) {
                this.left_chart = charts_list.slice(0, 3);
                this.right_chart = charts_list.slice(3, 6);
              }
            }
          } else {
            console.log("获取用户信息-=-=-=res.data.code === 3-=--=");
            let message = res.data.info;
            this.$message.error(message);
            localStorage.removeStore("info");
            localStorage.removeStore("loginStatus");
            this.$router.replace({
              path: "/login"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    closedrawer() {
      this.drawer = false;
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  // position:relative;
  // background: url("../../../static/img/bg-min.png") no-repeat;
  // background-size: 100% 100%;
  width: 100%;
  height: 100%;
  // background: url("../../../static/img/bg-min.png") no-repeat;
  background: url("https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/bg-min.png")
    no-repeat;
  background-size: 100% 100%;
  .header_content {
    // width:100%;
    // height:65px;
    // background:url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/title1.gif) no-repeat;
    // background: url(../../../static/img/tonghuatitle.gif) no-repeat;
    // background-size: 100% 100%;
  }
  .title_grep_div {
    background: url(../../../static/img/headbg.gif) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 65px;
    left: 0px;
    right: 0px;
    top: 0px;
    .title_grop_h1 {
      text-align: center;
      font-weight: bold;
      font-size: 39px;
      letter-spacing: 10px;
      background-image: -webkit-linear-gradient(top, #a6f0fa, #41c1f3, #006eff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .floor_content {
    width: 100%;
    height: 65px;
    position: absolute;

    // background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/title.gif) no-repeat;
    // background-size: 100% 100%;
  }

  .content {
    /*display:flex;*/
    /*height:calc(~'100% - ' 69px);*/
    /*position: relative;*/

    width: 100%;
    overflow: hidden;
    height: calc(~"100% - " 69px);
    .main-left {
      /*width:24%;*/
      /*z-index:1;*/
      /*height:100%;*/
      top: 7%;
      z-index: 1;
      left: 0px;
      width: 20%;
      height: 93%;
      position: absolute;
    }
    .main-right {
      /*width:24%;*/
      /*z-index:1;*/
      /*height:100%;*/

      top: 7%;
      z-index: 1;
      width: 20%;
      height: 93%;
      right: 0px;
      position: absolute;
    }
    .main-content-map {
      /*flex:1;*/
      /*width:52%;*/
      /*height: 100%;*/
      top: 65px;
      z-index: 0;
      height: 93%;
      width: 100%;
      position: absolute;
    }
    .list {
      position: fixed;
      bottom: 0%;
      height: 15%;
      left: 25%;
      //  background-color: chartreuse;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/main.vue